"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Subscribe;

var _react = _interopRequireWildcard(require("react"));

var _stripeJs = require("@stripe/stripe-js");

var _jquery = _interopRequireDefault(require("jquery"));

var _reactBootstrap = require("react-bootstrap");

var _components = require("../components");

var _functions = require("firebase/functions");

var _firebase = require("../firebase");

var _User = require("./User");

var _primitives = require("@bedrock-layout/primitives");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var createSession = (0, _functions.httpsCallable)((0, _functions.getFunctions)(), 'createCheckoutSession'); // Config data is imported from .env files, to allow for development to use a testing server

var stripePromise = (0, _stripeJs.loadStripe)(process.env.REACT_APP_STRIPE_KEY);
var plans = JSON.parse(process.env.REACT_APP_STRIPE_PLANS);
var tosUrl = '/terms.html';
var privacyPolicyUrl = '/privacy.html';
var firebaseFunctions = (0, _functions.getFunctions)();
var createPartnerCheckout = (0, _functions.httpsCallable)(firebaseFunctions, 'createPartnerCheckout');
var declinePartnership = (0, _functions.httpsCallable)(firebaseFunctions, 'declinePartnership');

function Subscribe(props) {
  var user = (0, _firebase.useAuth)();
  var priceRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)(""),
      _useState2 = _slicedToArray(_useState, 2),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  function setErrorToDisplay(e) {
    console.error(e);
    var msg = e.message || e;
    setErrorMessage(msg);
  }

  function submitForm(_x) {
    return _submitForm.apply(this, arguments);
  }

  function _submitForm() {
    _submitForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
      var price, sessionId, stripe;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e.preventDefault();
              price = priceRef.current.value; // validate input

              if (!(price < 0)) {
                _context.next = 6;
                break;
              }

              setErrorToDisplay("Positive Numbers Only ;)");
              _context.next = 22;
              break;

            case 6:
              if (!(price > 0 && price < 0.50)) {
                _context.next = 10;
                break;
              }

              setErrorToDisplay("The minimum value is $0.50, due to processing fees. ");
              _context.next = 22;
              break;

            case 10:
              if (!(price == 0)) {
                _context.next = 15;
                break;
              }

              _context.next = 13;
              return declinePartnership();

            case 13:
              _context.next = 22;
              break;

            case 15:
              _context.next = 17;
              return createPartnerCheckout({
                price: price,
                success_url: window.location.origin,
                cancel_url: window.location.href
              });

            case 17:
              sessionId = _context.sent.data;
              _context.next = 20;
              return stripePromise;

            case 20:
              stripe = _context.sent;
              stripe.redirectToCheckout({
                sessionId: sessionId
              }).catch(function (e) {
                console.error(e.message);
              });

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _submitForm.apply(this, arguments);
  }

  return /*#__PURE__*/_react.default.createElement(_primitives.Split, {
    fraction: "1/2",
    style: {
      minHeight: "100vh"
    }
  }, /*#__PURE__*/_react.default.createElement(_primitives.Cover, {
    className: "darkBackground",
    top: /*#__PURE__*/_react.default.createElement(_User.UserWidget, null)
  }, /*#__PURE__*/_react.default.createElement(_primitives.Stack, {
    as: "form",
    gap: 4,
    style: {
      padding: "5vw"
    },
    onSubmit: submitForm
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h1", null, "Your Memorization Journey!")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("p", null, "We've invested so much in developing these high quality products to serve you guys. In order to follow Christ's lead in servitude, we are choosing to not fix a high price point, but rather to give our work in support of God's people. If you choose, please give back to us according to however God has blessed you.")), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("input", {
    type: "number",
    "data-button": "round",
    name: "amount",
    placeholder: "$ Amount/Month",
    ref: priceRef,
    className: "form-control mt-3"
  }), /*#__PURE__*/_react.default.createElement("label", null, "Suggested $5/month subscription")), /*#__PURE__*/_react.default.createElement("button", {
    type: "submit",
    "data-button": "round outline negative",
    className: "btn mt-5 mb-5",
    id: "submitAuth"
  }, "Next"), /*#__PURE__*/_react.default.createElement("div", {
    id: "error-message",
    className: "text-danger"
  }, errorMessage))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: "5vw"
    }
  }, /*#__PURE__*/_react.default.createElement("ul", {
    "data-bullet": "circle-check"
  }, /*#__PURE__*/_react.default.createElement("li", null, "Complete digital Access to all updated By the Book ", /*#__PURE__*/_react.default.createElement("u", null, "memorization tools"), ":", /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "Basic Mnemonic tracks"), /*#__PURE__*/_react.default.createElement("li", null, "\u2018Looping\u2019 version"), /*#__PURE__*/_react.default.createElement("li", null, "\u2018Audio\u2019 version"), /*#__PURE__*/_react.default.createElement("li", null, "\u2018Visual\u2019 version"), /*#__PURE__*/_react.default.createElement("li", null, "\u2018Dance\u2019 version"), /*#__PURE__*/_react.default.createElement("li", null, "\u2018Echo\u2019 version"), /*#__PURE__*/_react.default.createElement("li", null, "\u2018Slow/Speed\u2019 version"), /*#__PURE__*/_react.default.createElement("li", null, "\u2018Blooper\u2019 version"), /*#__PURE__*/_react.default.createElement("li", null, "\u2018Karaoke\u2019 version"), /*#__PURE__*/_react.default.createElement("li", null, "\u2018Relax\u2019 version"))), /*#__PURE__*/_react.default.createElement("li", null, "Complete Digital access to all By the Book ", /*#__PURE__*/_react.default.createElement("u", null, "curriculum & products"), ":", /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "full pdf resource collection"), /*#__PURE__*/_react.default.createElement("li", null, "Coloring pages pdf"), /*#__PURE__*/_react.default.createElement("li", null, "Life-application story books pdf"), /*#__PURE__*/_react.default.createElement("li", null, "illustrated scripture books pdf"), /*#__PURE__*/_react.default.createElement("li", null, "Craft/Activities pdf"), /*#__PURE__*/_react.default.createElement("li", null, "Copywork pdf"), /*#__PURE__*/_react.default.createElement("li", null, "Vocabulary page pdf"), /*#__PURE__*/_react.default.createElement("li", null, "Worksheet pdf"), /*#__PURE__*/_react.default.createElement("li", null, "Sheet music pdf"), /*#__PURE__*/_react.default.createElement("li", null, "Supporting lesson videos"), /*#__PURE__*/_react.default.createElement("li", null, "Life-application story videos"), /*#__PURE__*/_react.default.createElement("li", null, "Visual illustration videos"), /*#__PURE__*/_react.default.createElement("li", null, "Princess exposition video"), /*#__PURE__*/_react.default.createElement("li", null, "\u2018Schmo toon\u2019 life-application video"))), /*#__PURE__*/_react.default.createElement("li", null, "Complete digital access to all ", /*#__PURE__*/_react.default.createElement("u", null, "updated BtB content"), ": (currently including)", /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "James (all 5 chapters)"), /*#__PURE__*/_react.default.createElement("li", null, "1 John (all 5 chapters)"), /*#__PURE__*/_react.default.createElement("li", null, "Malachi (all 4 chapters)"), /*#__PURE__*/_react.default.createElement("li", null, "Matthew (chapter 5-7)"), /*#__PURE__*/_react.default.createElement("li", null, "Psalm 1"), /*#__PURE__*/_react.default.createElement("li", null, "Various other passages"))))));
}